import * as types from './types';
import createReducer from '../../createReducer';
import { FETCH_STATE } from 'constants';

const initialState = {
  logs: [],
  fetchingLogs: FETCH_STATE.UNSENT,
  pagination: {},
};

const logsReducer = createReducer(initialState)({
  [types.FETCH_LOGS_REQUEST]: (state) => {
    return {
      ...state,
      fetchingLogs: FETCH_STATE.LOADING,
      logs: [],
      pagination: {},
    };
  },
  [types.FETCH_LOGS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingLogs: FETCH_STATE.DONE,
      logs: payload.data || [],
      pagination: payload.pagination,
    };
  },
  [types.FETCH_LOGS_FAILED]: (state, { error }) => {
    return {
      ...state,
      fetchingLogs: FETCH_STATE.ERROR,
    };
  },
});

export default logsReducer;
